var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5, 0.5)",
    fill: "none",
    stroke: "currentColor",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.651,44.049A8.971,8.971,0,0,1,51,47H47",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.349,44.049A8.971,8.971,0,0,0,13,47h4",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,21h2.5A7.5,7.5,0,0,0,32,13.5v-2a7.5,7.5,0,0,0-14.858-1.442C16.766,10.022,16.385,10,16,10A11.989,11.989,0,0,0,7.751,30.7a8.972,8.972,0,0,0-1.4,13.349A13,13,0,1,0,32,47",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,21H39.5A7.5,7.5,0,0,1,32,13.5v-2a7.5,7.5,0,0,1,14.858-1.442C47.234,10.022,47.615,10,48,10a11.989,11.989,0,0,1,8.249,20.7,8.972,8.972,0,0,1,1.4,13.349A13,13,0,1,1,32,47",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,30.021A4.986,4.986,0,0,1,43,39",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,30.021A4.986,4.986,0,0,0,21,39",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 46.933,
    x2: 32,
    y2: 36,
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 21,
    r: 3,
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 47,
    r: 3,
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 33,
    r: 3,
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 21,
    r: 3,
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 47,
    r: 3,
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,34a11.948,11.948,0,0,0,8.249-3.3",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.751,30.7A11.948,11.948,0,0,0,16,34",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.54b7a2b42981da2913625684808ee9cb.svg";
export { ForwardRef as ReactComponent };